import projectData from "./project-data";

/* eslint-disable import/no-unresolved */
import popWav from "!arraybuffer-loader!./83a9787d4cb6f3b7632b4ddfebf74367.wav?";
import meowWav from "!arraybuffer-loader!./83c36d806dc92327b9e7049a565c6bff.wav?";
import backdrop from "!raw-loader!./cd21514d0531fdffb22204e0ec5ed84a.svg?";
import costume0 from "!raw-loader!./0fb9be3e8397c983338cb71dc84d0b25.svg?";
import costume01 from "!raw-loader!./dc166ebfaacc9b91a94798b036845e91.svg?";
import costume02 from "!raw-loader!./0b9a685e7c30fff2f320965e27c06655.svg?";
import costume03 from "!raw-loader!./be4dedf792dc01cab0dfe40e6513ec75.svg?";
import custome04 from "!raw-loader!./bec1e702662b75f5906671848a4d0682.svg?";
import custome05 from "!raw-loader!./bec1e702662b75f5906671848a4d0683.svg?";
/* eslint-enable import/no-unresolved */

const defaultProject = (translator) => {
    let _TextEncoder;
    if (typeof TextEncoder === "undefined") {
        _TextEncoder = require("fastestsmallesttextencoderdecoder").TextEncoder;
    } else {
        _TextEncoder = TextEncoder;
    }
    const encoder = new _TextEncoder();

    const projectJson = projectData(translator);
    return [
        {
            id: 0,
            assetType: "Project",
            dataFormat: "JSON",
            data: JSON.stringify(projectJson),
        },
        {
            id: "83a9787d4cb6f3b7632b4ddfebf74367",
            assetType: "Sound",
            dataFormat: "WAV",
            data: new Uint8Array(popWav),
        },
        {
            id: "83c36d806dc92327b9e7049a565c6bff",
            assetType: "Sound",
            dataFormat: "WAV",
            data: new Uint8Array(meowWav),
        },
        {
            id: "cd21514d0531fdffb22204e0ec5ed84a",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(backdrop),
        },
        {
            id: "0fb9be3e8397c983338cb71dc84d0b25",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(costume0),
        },
        {
            id: "dc166ebfaacc9b91a94798b036845e91",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(costume01),
        },
        {
            id: "0b9a685e7c30fff2f320965e27c06655",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(costume02),
        },
        {
            id: "be4dedf792dc01cab0dfe40e6513ec75",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(costume03),
        },
        {
            id: "bec1e702662b75f5906671848a4d0682",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(custome04),
        },
        {
            id: "bec1e702662b75f5906671848a4d0683",
            assetType: "ImageVector",
            dataFormat: "SVG",
            data: encoder.encode(custome05),
        },
    ];
};

export default defaultProject;
